import { ApplicationStatusType, MultiplePartnerLoanStatusType } from '../types';
import {
  SET_APPLICATION_PAYLOAD,
  SET_APPLICATION_STATUS,
  SET_LANDING_PAGE_DATA,
  SET_LOAN_AMOUNT,
} from './types';

const initPersonalLoan: {
  loanAmount: number;
  applicationStatus: ApplicationStatusType | null;
  applicationPayload: any | null;
  landingPageData: MultiplePartnerLoanStatusType | null;
} = {
  loanAmount: 0,
  applicationStatus: null,
  applicationPayload: null,
  landingPageData: null,
};

export function personalLoan(state = initPersonalLoan, action) {
  const {
    type,
    applicationStatus,
    applicationPayload,
    landingPageData,
    loanAmount,
  } = action;

  switch (type) {
    case SET_APPLICATION_STATUS:
      return { ...state, applicationStatus };

    case SET_APPLICATION_PAYLOAD:
      return { ...state, applicationPayload };
    case SET_LANDING_PAGE_DATA:
      return { ...state, landingPageData };

    case SET_LOAN_AMOUNT:
      return { ...state, loanAmount };

    default:
      return state;
  }
}
